import { useEffect, useState } from 'react';

import {
  useAppwatchSelector,
  useAppwatchDispatch,
  PaymentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ChartDisplay } from '@wajeez-web/components/ui';
import { ChartHeader } from '../ChartHeader';
import { ChartsProps } from '../types';
import { AppWatch } from '@wajeez/wajeez.microservices';
import { groupBy } from '@wajeez-web/core/utils';
import moment from 'moment';

const DailyLostPremiumUsersChart = ({ dates }: ChartsProps) => {
  const dispatch = useAppwatchDispatch();
  const { dailyLostPremiumUsers, dailyLostPremiumUsersStatus } =
    useAppwatchSelector((c) => c.paymentAnalysis);
  const [userLostSubscriptionDuration, setUserLostSubscriptionDuration] =
    useState<AppWatch.SubscriptionDuration | null>(null);
  const [subscriptionType, setSubscriptionType] = useState<
    AppWatch.SubscriptionType | undefined
  >(undefined);

  useEffect(() => {
    dispatch(
      PaymentAnalysisActions.getDailyLostPremiumUsersAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
        SubscriptionDuration: userLostSubscriptionDuration,
      })
    );
  }, [userLostSubscriptionDuration, dates]);

  return (
    <div className="col-span-2 ">
      {' '}
      <Card>
        <div className="space-y-2">
          <ChartHeader
            title="Daily lost premium users"
            SubscriptionDurationAction={(duration) =>
              setUserLostSubscriptionDuration(duration)
            }
            dates={dates}
          />

          <ChartDisplay
            loading={dailyLostPremiumUsersStatus === 'loading'}
            formatter={(value, time) => {
              return (
                moment.utc(value).local().locale('en').format('DD/MM/YYYY') ||
                value
              );
            }}
            xAxistype="datetime"
            chartType="area"
            seriesData={[
              {
                type: 'area',
                name: 'Users',
                data:
                  subscriptionType == null
                    ? groupBy(
                        dailyLostPremiumUsers,
                        (d) => d.expirationDate ?? ''
                      ).map((f) => ({
                        x: f.key,
                        y: f.data.reduce((a, b) => a + (b.count ?? 0), 0),
                      }))
                    : dailyLostPremiumUsers.map((d) => ({
                        x: d.expirationDate,
                        y: d.count || '',
                      })),
              },
            ]}
          />
        </div>
      </Card>
    </div>
  );
};

export default DailyLostPremiumUsersChart;
